import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useSsaFilteredRoutes = (routes) => {
  const { pathname } = useLocation();

  const ssaRoutes = ['/ssa/online-attendance-compliance-app'];

  const isSsa = ssaRoutes.some((path) => pathname.startsWith(path));

  const filteredRoutes = useMemo(() => {
    if (isSsa) {
      // In SSA mode: show only routes with showInSsaMode flag
      return routes
        .filter((r) => r.showInSsaMode || r.key === 'application')
        .map((r) => {
          if (r.key === 'application') {
            return {
              ...r,
              collapse: r.collapse?.filter((item) => item.showInSsaMode),
            };
          }
          return r;
        });
    } else {
      // Normal mode: hide showInSsaMode routes
      return routes
        .filter((r) => !r.showInSsaMode)
        .map((r) => {
          if (r.collapse) {
            return {
              ...r,
              collapse: r.collapse.filter((item) => !item.showInSsaMode),
            };
          }
          return r;
        });
    }
  }, [pathname, routes]);

  return { filteredRoutes, isSsa };
};

export default useSsaFilteredRoutes;
